import { Select, Tag } from '@bitcine/cinesend-theme/dist'
import { useQuery } from '@tanstack/react-query'

const CollectionDropdown = ({ field, label, value, isLoading, languageID = null, saveField, cycleID }) => {
  const { data, isLoading: isLoadingOptions } = useQuery([
    `/api/collection-list/${field.collection_id}/${cycleID}/${languageID ?? ''}`,
  ])
  const options = data ? data.map((option) => ({ value: option.id, label: option.label })) : []
  return (
    <Select
      label={label ?? field.name}
      isLoading={isLoading || isLoadingOptions}
      value={
        field.is_multi_select
          ? (() => {
              if (!value) return []
              try {
                const parsed = JSON.parse(value)
                // Let's check if the value is an array. If it is, we map each value to its corresponding option.
                // Otherwise it's probably a "bad" value from a previous import. We'll just display it as is
                return Array.isArray(parsed)
                  ? parsed.map((val) => options.find((opt) => opt.value === val) || { value: val, label: val })
                  : [{ value: parsed, label: parsed }]
              } catch {
                return [{ value, label: value }]
              }
            })()
          : options.find((opt) => String(opt.value) === String(value)) || (value ? { value, label: value } : null)
      }
      options={options}
      isMulti={field.is_multi_select}
      disabled={field?.is_external_api_value_source}
      onChange={(opt) => {
        if (field.is_multi_select) {
          saveField(JSON.stringify(opt.map((opt) => opt.value)))
        } else {
          saveField(opt.value)
        }
      }}
    />
  )
}

const LanguageDropdown = ({ field, label, value, isLoading, saveField }) => {
  const { data, isLoading: isLoadingOptions } = useQuery(['/api/languages'])
  const options = data ? data.map((option) => ({ value: option.id, label: option.eng_description })) : []
  return (
    <Select
      label={label ?? field.name}
      isLoading={isLoading || isLoadingOptions}
      isClearable
      disabled={field?.is_external_api_value_source}
      value={options.find((opt) => (value ? opt.value == JSON.parse(value) : false))}
      options={options}
      onChange={(opt) => saveField(opt ? opt.value : null)}
    />
  )
}

const Dropdown = ({ field, ...props }) => {
  if (field.collection_id && !field.use_languages) {
    return <CollectionDropdown field={field} {...props} />
  } else if (field.use_languages) {
    return <LanguageDropdown field={field} {...props} />
  }
  return <Tag outline type='error' label='Undefined Dropdown' />
}

export default Dropdown
